import { gql } from 'apollo-angular';

export const LIST_PETTY_CASH = gql`
  query pettyCashes($search: String) {
    pettyCashes(search: $search) {
      id
      projectId
      projectData {
        id
        projectCode
        projectName
      }
      employeeId
      projectEngineerData {
        id
        firstName
        lastName
        middleName
      }
      pettyCashNumber
      category
      flow
      date
      description
      amount
      vat
    }
  }
`;

export const PETTY_CASH_ACCOUNTS = gql`
  query pettyCashAccounts($search: String, $isActive: Boolean) {
    pettyCashAccounts(search: $search, isActive: $isActive) {
      id
      branchId
      branchData {
        id
        branchName
        address
        branchCode
      }
      employeeId
      # activityStatus
      employeeData {
        id
        firstName
        lastName
        middleName
        dateOfBirth
        gender
        email
        phoneNumber
        alternatePhoneNumber
        address
        permanentAddress
        dateOfJoining
        employmentType
        employeeType
        employeeStatus
        profilePicture
        maritalStatus
        nationality
        passportNumber
        visaType
        visaIssueDate
        visaExpiryDate
        salary
        bankName
        bankAccountNumber
        IFSCCode
      }
      pettyCashNumber
      openingBalance
      currentBalance
      currencyId
      currencyData {
        id
        currencyCode
      }
      isActive
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const LIST_PETTY_CASH_ACTIVITIES = gql`
  query pettyCashActivities($pettyCashId: Int!) {
    pettyCashActivities(pettyCashId: $pettyCashId) {
      id
      description
      expenseType
      activityStatus
      type
      amount
      cashAccountData {
        id
        pettyCashNumber
        openingBalance
        currentBalance
        currencyId
        isActive
        branchId
        createdAt
      }
      approvedOrRejectedByData {
        id
        firstName
        lastName
      }
      accountData {
        id
        accountName
      }
      journalData {
        id
        journalNo
        createdAt
      }
      activityStatus
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const PETTY_CASH_DETAIL = gql`
  query getPettyCashesByCategory($category: String!, $id: String!) {
    getPettyCashesByCategory(category: $category, id: $id) {
      pettyCashes {
        id
        projectId
        accountId
        category
        employeeId
        flow
        date
        description
        paymentMode
        pettyCashNumber
        amount
        vat
        chequeNumber
        chequeDate
        status
        fileName
        fileUrl
        # pettyCashUrl
        createdAt
        updatedAt
      }
      totalInFlow
      totalOutFlow
      balance
    }
  }
`;

export const FIND_ACCOUNTS_BY_TYPES = gql`
  query findAccountsByMultipleTypes(
    $accountTypes: [AccountType!]
    $search: String
  ) {
    findAccountsByMultipleTypes(accountTypes: $accountTypes, search: $search) {
      id
      accountName
      accountCode
      accountType
    }
  }
`;

export const GET_PETTY_CASH_ACTIVITY = gql`
  query pettyCashActivity($id: Int!) {
    pettyCashActivity(id: $id) {
      id
      cashAccountId
      type
      amount
      expenseType
      accountId
      description
      receiptUrl
      approvedorRejectedBy
      IsApproved
      journalId
      activityStatus
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const EMPLOYEE_PETTY_CASH_STATUS = gql`
  query employeeHasPettyCash($employeeId: Int!) {
    employeeHasPettyCash(employeeId: $employeeId)
  }
`;
